import { underlineLinkStyle } from '@bingads-webui-campaign-react/common-styles';

const couponColor = '#138486';

const tagHeight = 24;

const couponFlag = {
  '& .coupon-right-aligned': {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  '& .coupon-tag': {
    color: 'white',
    display: 'flex',
    height: tagHeight,
    width: 'fit-content',
    position: 'relative',
    '& ~ .oppt_detail, & ~ .tip_image_container': {
      marginTop: tagHeight,
    },
    '& .coupon-tag-main-triangle': {
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: [tagHeight / 2, 10],
      borderColor: [couponColor, couponColor, couponColor, 'transparent'],
      marginRight: -1,
    },
    '& .coupon-tag-message': {
      backgroundColor: couponColor,
      height: tagHeight,
      padding: [5, 10, 5, 0],
      fontSize: 10,
      boxSizing: 'border-box',
    },
  },
};

export const getDefaultTipCardStyle = ({ palette = {} }) => ({
  '.tips-card': {
    ...couponFlag,
    display: 'flex',
    minHeight: 0.1,
    width: '100%',
    '& .deterministic-wrapper-view': {
      width: '100%',
    },
    '& .visuallyhidden': {
      border: '0',
      clip: 'rect(0 0 0 0)',
      height: '1px',
      margin: '-1px',
      overflow: 'hidden',
      padding: '0',
      position: 'absolute',
      width: '1px',
    },
    '& .tipsCarousel': {
      height: 'auto',
      display: 'flex',
      width: '100%',
      '& .carousel-inner': {
        display: 'flex',
        padding: '0',
      },
      '& .carousel-inner .item': {
        flex: '1',
        height: 'auto',
        minWidth: 1,
      },
      '& .carousel-footer': {
        display: 'flex',
        padding: '0',
        position: 'absolute',
        bottom: 0,
      },
      '& .carousel-footer .inactiveButton': {
        display: 'none',
      },
      '& .carousel-inner .carousel__tip_content': {
        display: 'flex',
        flex: '1',
        flexDirection: 'column',
      },
      '& .carousel-inner .carousel__tip_content .tip_text_content': {
        display: 'flex',
        flex: '3 3',
        flexDirection: 'column',
        order: 2,
      },
      '& .carousel-inner .carousel__tip_content .tip_text_content .tip_title': {
        textDecoration: 'none',
        margin: '12px 0px',
        overflow: 'hidden',
        flex: '0 1 auto',
        minHeight: 1,
        lineHeight: 'normal',
        fontSize: '18px',
        fontWeight: '600',
      },
      '& .carousel-inner .carousel__tip_content .tip_text_content .tip_description__wrapper': {
        display: 'block',
        flex: '1 100',
        overflow: 'hidden',
      },
      '& .carousel-inner .carousel__tip_content .tip_text_content .tip_description__wrapper .tip_description': {
        lineHeight: '20px',
        height: 'auto',
        overflow: 'hidden',
        fontSize: '14px',
        fontWeight: 'normal',
        margin: '0',
      },
      '& .carousel-inner .carousel__tip_content .tip_text_content .tip_links': {
        marginTop: 16,
        display: 'flex',
        flexShrink: '0',
        marginBottom: 16,
      },
      '& .carousel-inner .carousel__tip_content .tip_text_content .tip_links .linkButton': {
        lineHeight: '30px',
      },
      '& .carousel-inner .item .carousel__tip_content .tip_text_content .tip_links': {
        marginBottom: 44,
      },
      '& .carousel-inner .carousel__tip_content .tip_text_content .tip_links .tip_clickLink': {
        flex: '0 0 auto',
        '&.secondary_ClickLink': {
          marginLeft: 8,
        },
      },
      '& .carousel-inner .carousel__tip_content .tip_text_content .tip_links .tip_dismissLink': {
        marginLeft: 30,
        paddingTop: 5,
      },
      '& .carousel-inner .carousel__tip_content .tip_text_content .tip_links .tip_dismissLink a': {
        position: 'relative',
        color: '#1570A5',
      },
      '& .carousel-inner .carousel__tip_content .tip_image_container': {
        flex: '2 2',
        minWidth: '0.1px',
        display: 'flex',
        justifyContent: 'flex-end',
        order: 1,
        marginTop: '1px',
        flexDirection: 'column',
      },
      '& .carousel-inner .carousel__tip_content .tip_image_container .tip_image': {
        flex: '1',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
      },
      '& .carousel-inner .carousel__welcome_content': {
        display: 'flex',
        flex: '1',
        flexDirection: 'column',
      },
      '& .carousel-inner .carousel__welcome_content .welcome_text_content': {
        display: 'flex',
        flex: '3 3',
        flexDirection: 'column',
        order: 2,
      },
      '& .carousel-inner .carousel__welcome_content .welcome_text_content .welcome_title': {
        textDecoration: 'none',
        margin: '12px 0px',
        overflow: 'hidden',
        flex: '0 1 auto',
        minHeight: 1,
        lineHeight: 'normal',
        fontSize: '18px',
        fontWeight: '600',
      },
      '& .carousel-inner .carousel__welcome_content .welcome_text_content .welcome_description__wrapper': {
        display: 'block',
        flex: '1 100',
        overflow: 'hidden',
      },
      '& .carousel-inner .carousel__welcome_content .welcome_text_content .welcome_description__wrapper .welcome_description': {
        lineHeight: '20px',
        height: 'auto',
        overflow: 'hidden',
        fontSize: '14px',
        fontWeight: 'normal',
        margin: '0',
      },
      '& .carousel-inner .carousel__welcome_content .welcome_text_content .welcome_links': {
        marginTop: 10,
        display: 'flex',
        flexShrink: '0',
        marginBottom: 55,
      },
      '& .carousel-inner .carousel__welcome_content .welcome_text_content .welcome_links .welcome_clickLink': {
        flex: '0 0 auto',
      },
      '& .carousel-inner .carousel__welcome_content .welcome_text_content .welcome_links .welcome_clickLink .linkButton': {
        lineHeight: '30px',
      },
      '& .carousel-inner .carousel__welcome_content .welcome_text_content .welcome_links .disabled-button': {
        flex: '0 0 auto',
      },
      '& .carousel-inner .carousel__welcome_content .welcome_text_content .welcome_links .disabled-button .btn-default.btn': {
        fontWeight: 'bold',
        fontSize: '13px',
        paddingTop: 5,
        paddingBottom: 5,
        paddingLeft: 10,
        paddingRight: 10,
        boxShadow: 'none',
        borderRadius: '0',
        color: '#666666',
        backgroundColor: '#F4F4F4',
        fallbacks: [
          {
            border: '0',
          },
        ],
        cursor: 'default',
      },
      '& .carousel-inner .carousel__welcome_content .welcome_text_content .welcome_links .disabled-button .btn-default.btn:focus': {
        outline: '0',
      },
      '& .carousel-inner .carousel__welcome_content .welcome_image_container': {
        flex: '2 2',
        minWidth: '0.1px',
        display: 'flex',
        justifyContent: 'center',
        order: 1,
        marginTop: '1px',
      },
      '& .carousel-inner .carousel__welcome_content .welcome_image_container .welcome_image': {
        flex: '1',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
      },
      '& .carousel-inner .carousel__oppt_content': {
        display: 'flex',
        flexDirection: 'column',
        flex: '1',
        minWidth: 1,
        margin: '16px 0 0',
      },
      '& .carousel-inner .carousel__oppt_content .oppt_detail': {
        display: 'flex',
        flex: '1',
        minHeight: 1,
      },
      '& .carousel-inner .carousel__oppt_content .oppt_detail .oppt_text_content': {
        flex: '3 3',
        minWidth: 1,
        display: 'flex',
        flexDirection: 'column',
      },
      '& .carousel-inner .carousel__oppt_content .oppt_detail .oppt_text_content .oppt_title': {
        fontSize: '18px',
        lineHeight: '22px',
        marginBottom: '8px',
        fontWeight: '600',
      },
      '& .carousel-inner .carousel__oppt_content .oppt_detail .oppt_text_content .oppt_description': {
        fontSize: '13px',
        lineHeight: '18px',
        overflowY: 'auto',
        color: palette.neutralSecondary,
        ...underlineLinkStyle({ palette, elementLocator: '> a' }),
      },
      '& .carousel-inner .carousel__oppt_content .oppt_detail .oppt_content .oppt_description_detail': {
        maxWidth: '200px',
        color: palette.neutralSecondary,
      },
      '& .carousel-inner .carousel__oppt_content .oppt_detail .oppt_content': {
        marginRight: '25px',
        fontWeight: '600',

        '& .kpis': {
          '& .oppt_kpi.kpi-primary': {
            display: 'block',
            '& .kpi_name': {
              fontSize: '12px',
              color: '#107C10',
            },
            '& .kpi_delta': {
              display: 'flex',
              alignItems: 'center',
              fontSize: '30px',
              lineHeight: '40px',
              color: '#107C10',
              marginRight: '0px',

              '& .increase-arrow:before': {
                content: '"\\EE68"',
                fontFamily: 'MsAds MDL2 Assets',
              },
              '& .decrease-arrow:before': {
                content: '"\\EE69"',
                fontFamily: 'MsAds MDL2 Assets',
              },
            },
            '& .kpi_change': {
              fontSize: '12px',
              lineHeight: '16px',
              marginBottom: '10px',
            },
          },
          '& .oppt_kpi': {
            display: 'flex',
            '& .positive-estimate': {
              color: '#107C10',
            },
          },
          '& .oppt_kpi.kpi-secondary': {
          },
          '& .kpi_delta': {
            display: 'flex',
            marginRight: '5px',
          },
        },
        '& .kpi_description': {
          marginTop: '10px',
          color: palette.neutralSecondary,
        },
      },
      '& .carousel-inner .carousel__oppt_content .oppt_detail .oppt_image_container': {
        flex: '1 1',
        minWidth: 1,
        display: 'flex',
        justifyContent: 'center',
        marginTop: '12px',
        marginBottom: '16px',
      },
      '& .carousel-inner .carousel__oppt_content .oppt_detail .oppt_image_container .oppt_image': {
        flex: '1',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
      },
      '& .carousel-inner .carousel__oppt_content .oppt_action': {
        flex: '0 0 75px',
        minHeight: 75,
      },
      '& .carousel-inner .carousel__oppt_content .oppt_action .oppt_clickLink': {
        flex: '0 0 auto',
      },
      '& .carousel-inner .empty_content': {
        margin: '20px 10px 0',
      },
      '& .carousel-inner .active, .carousel-inner .next, .carousel-footer .activeButton, .carousel-inner .prev, .carousel-inner .left, .carousel-inner .right': {
        display: 'flex',
      },
      '& .carousel-inner .next, .carousel-inner .prev': {
        height: '100%',
      },
    },
  },
});
